(function () {
  let productObserver = null;
  const overlayInitAttr = 'data-sizes-overlay-initialized';

  function isMobileNow() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function initProductObserver() {
    const products = document.querySelectorAll('.product-item');

    if (productObserver) productObserver.disconnect();

    productObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const overlay = entry.target.querySelector('.sizes-overlay');
        if (!overlay) return;

        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          overlay.classList.add('flash');
          setTimeout(() => overlay.classList.remove('flash'), 600);
        } else {
          entry.target.classList.remove('visible');
        }
      });
    }, { threshold: 0.6 });

    products.forEach((p) => productObserver.observe(p));
  }

  function initOneOverlay(overlay) {
    if (!overlay || overlay.getAttribute(overlayInitAttr) === 'true') return;

    const list = overlay.querySelector('.sizes-list');
    const upBtn = overlay.querySelector('#scroll-up');
    const downBtn = overlay.querySelector('#scroll-down');
    const upContainer = overlay.querySelector('.top-arrow');
    const downContainer = overlay.querySelector('.bottom-arrow');
    const jump = 250;

    if (!list || !upBtn || !downBtn || !upContainer || !downContainer) return;

    overlay.setAttribute(overlayInitAttr, 'true');

    const scrollSmooth = (amount) => {
      list.scrollBy({ top: amount, behavior: 'smooth' });
    };

    const updateArrows = () => {
      const maxScroll = list.scrollHeight - list.clientHeight;

      if (maxScroll <= 0) {
        upContainer.style.display = 'none';
        downContainer.style.display = 'none';
        return;
      }

      const top = list.scrollTop;
      const atTop = top <= 1;
      const atBottom = top >= (maxScroll - 1);

      if (atTop) {
        upContainer.style.display = 'none';
        downContainer.style.display = 'flex';
        return;
      }

      if (atBottom) {
        upContainer.style.display = 'flex';
        downContainer.style.display = 'none';
        return;
      }

      upContainer.style.display = 'flex';
      downContainer.style.display = 'flex';
    };

    const updateActive = () => {
      const items = list.querySelectorAll('.size');
      if (!items.length) return;

      items.forEach((i) => i.classList.remove('is-active'));
      const index = Math.round(list.scrollTop / items[0].offsetHeight);
      if (items[index]) items[index].classList.add('is-active');
    };

    const productId = overlay.closest('.product-item')?.dataset?.productId || '';
    const key = `sizes-scroll-${productId}`;

    const saved = sessionStorage.getItem(key);
    if (saved) list.scrollTop = parseInt(saved, 10);

    list.addEventListener('scroll', () => {
      updateArrows();
      updateActive();
      sessionStorage.setItem(key, list.scrollTop);
    });

    overlay.addEventListener('wheel', (e) => {
      e.preventDefault();
      scrollSmooth(e.deltaY > 0 ? jump : -jump);
      setTimeout(updateArrows, 160);
    }, { passive: false });

    upBtn.addEventListener('click', (e) => {
      e.preventDefault();
      scrollSmooth(-jump);
      setTimeout(updateArrows, 160);
    });

    downBtn.addEventListener('click', (e) => {
      e.preventDefault();
      scrollSmooth(jump);
      setTimeout(updateArrows, 160);
    });

    overlay.addEventListener('click', (e) => {
      if (!e.target.classList.contains('sizes-button')) {
        e.stopPropagation();
        e.preventDefault();
      }
    });

    if (isMobileNow()) {
      let startY = 0;

      overlay.addEventListener('touchstart', (e) => {
        startY = e.touches[0].clientY;
      }, { passive: true });

      overlay.addEventListener('touchend', (e) => {
        const endY = e.changedTouches[0].clientY;
        const deltaY = startY - endY;

        if (Math.abs(deltaY) > 10) {
          scrollSmooth(deltaY > 0 ? jump : -jump);
          setTimeout(updateArrows, 160);
        }
      }, { passive: true });
    }

    updateArrows();
    updateActive();
  }

  function initAllOverlays(root = document) {
    root.querySelectorAll('.sizes-overlay').forEach(initOneOverlay);
  }

  function boot() {
    initAllOverlays(document);
    initProductObserver();
  }

  function watchForNewProducts() {
    const target = document.body;
    if (!target) return;

    const mo = new MutationObserver((mutations) => {
      let found = false;

      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches?.('.product-item') || node.querySelector?.('.product-item') || node.matches?.('.sizes-overlay') || node.querySelector?.('.sizes-overlay')) {
            found = true;
            break;
          }
        }
        if (found) break;
      }

      if (found) {
        initAllOverlays(document);
        initProductObserver();
      }
    });

    mo.observe(target, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    boot();
    watchForNewProducts();
  });

  window.addEventListener('pageshow', () => {
    boot();
  });

  document.addEventListener('shopify:section:load', () => {
    boot();
  });

})();
